export const SCORE_SCALES = [
  {
    scale: 300,
    title: 'Very Weak',
    subtitle: '300-528',
    color: '#ED1C24',
  },
  {
    scale: 529,
    title: 'Weak',
    subtitle: '529-650',
    color: '#F7941E',
  },
  {
    scale: 651,
    title: 'Below Average',
    subtitle: '651-696',
    color: '#F2E300',
  },
  {
    scale: 697,
    title: 'Above Average',
    subtitle: '697-717',
    color: '#D8DA17',
  },
  {
    scale: 718,
    title: 'Good',
    subtitle: '718-743',
    color: '#A6CE39',
  },
  {
    scale: 744,
    title: 'Excellent',
    subtitle: '744-850',
    color: '#00984A',
  },
  {
    scale: 0,
    title: 'No score',
    subtitle: null,
    color: '#A6A6A6',
  },
].sort((a, b) => b.scale - a.scale);



// WEBPACK FOOTER //
// ./src/constants/scoreScales.js